export const English = {
    ABBREVIATIONS: [
        "Adj.",
        "Adm.",
        "Adv.",
        "Al.",
        "Ala.",
        "Alta.",
        "Apr.",
        "Arc.",
        "Ariz.",
        "Ark.",
        "Art.",
        "Assn.",
        "Asst.",
        "Attys.",
        "Aug.",
        "Ave.",
        "Bart.",
        "Bld.",
        "Bldg.",
        "Blvd.",
        "Brig.",
        "Bros.",
        "Btw.",
        "Cal.",
        "Calif.",
        "Capt.",
        "Cl.",
        "Cmdr.",
        "Co.",
        "Col.",
        "Colo.",
        "Comdr.",
        "Con.",
        "Conn.",
        "Corp.",
        "Cpl.",
        "Cres.",
        "Ct.",
        "D.phil.",
        "Dak.",
        "Dec.",
        "Del.",
        "Dept.",
        "Det.",
        "Dist.",
        "Dr.",
        "Dr.phil.",
        "Dr.philos.",
        "Drs.",
        "E.g.",
        "Ens.",
        "Esp.",
        "Esq.",
        "Etc.",
        "Exp.",
        "Expy.",
        "Ext.",
        "Feb.",
        "Fed.",
        "Fla.",
        "Ft.",
        "Fwy.",
        "Fy.",
        "Ga.",
        "Gen.",
        "Gov.",
        "Hon.",
        "Hosp.",
        "Hr.",
        "Hway.",
        "Hwy.",
        "I.e.",
        "Ia.",
        "Id.",
        "Ida.",
        "Ill.",
        "Inc.",
        "Ind.",
        "Ing.",
        "Insp.",
        "Is.",
        "Jan.",
        "Jr.",
        "Jul.",
        "Jun.",
        "Kan.",
        "Kans.",
        "Ken.",
        "Ky.",
        "La.",
        "Lt.",
        "Ltd.",
        "Maj.",
        "Man.",
        "Mar.",
        "Mass.",
        "May.",
        "Md.",
        "Me.",
        "Med.",
        "Messrs.",
        "Mex.",
        "Mfg.",
        "Mich.",
        "Min.",
        "Minn.",
        "Miss.",
        "Mlle.",
        "Mm.",
        "Mme.",
        "Mo.",
        "Mont.",
        "Mr.",
        "Mrs.",
        "Ms.",
        "Msgr.",
        "Mssrs.",
        "Mt.",
        "Mtn.",
        "Neb.",
        "Nebr.",
        "Nev.",
        "No.",
        "Nos.",
        "Nov.",
        "Nr.",
        "Oct.",
        "Ok.",
        "Okla.",
        "Ont.",
        "Op.",
        "Ord.",
        "Ore.",
        "P.",
        "Pa.",
        "Pd.",
        "Pde.",
        "Penn.",
        "Penna.",
        "Pfc.",
        "Ph.",
        "Ph.d.",
        "Pl.",
        "Plz.",
        "Pp.",
        "Prof.",
        "Pvt.",
        "Que.",
        "Rd.",
        "Rs.",
        "Ref.",
        "Rep.",
        "Reps.",
        "Res.",
        "Rev.",
        "Rt.",
        "Sask.",
        "Sec.",
        "Sen.",
        "Sens.",
        "Sep.",
        "Sept.",
        "Sfc.",
        "Sgt.",
        "Sr.",
        "St.",
        "Supt.",
        "Surg.",
        "Tce.",
        "Tenn.",
        "Tex.",
        "Univ.",
        "Usafa.",
        "U.S.",
        "Ut.",
        "Va.",
        "V.",
        "Ver.",
        "Vs.",
        "Vt.",
        "Wash.",
        "Wis.",
        "Wisc.",
        "Wy.",
        "Wyo.",
        "Yuk."
    ],
    PREPOSITIVE_ABBREVIATIONS: [
        "Adm.",
        "Attys.",
        "Brig.",
        "Capt.",
        "Cmdr.",
        "Col.",
        "Cpl.",
        "Det.",
        "Dr.",
        "Gen.",
        "Gov.",
        "Ing.",
        "Lt.",
        "Maj.",
        "Mr.",
        "Mrs.",
        "Ms.",
        "Mt.",
        "Messrs.",
        "Mssrs.",
        "Prof.",
        "Ph.",
        "Rep.",
        "Reps.",
        "Rev.",
        "Sen.",
        "Sens.",
        "Sgt.",
        "St.",
        "Supt.",
        "V.",
        "Vs."
    ],
    EXCLAMATION_WORDS: [
        "!Xũ",
        "!Kung",
        "ǃʼOǃKung",
        "!Xuun",
        "!Kung-Ekoka",
        "ǃHu",
        "ǃKhung",
        "ǃKu",
        "ǃung",
        "ǃXo",
        "ǃXû",
        "ǃXung",
        "ǃXũ",
        "!Xun",
        "Yahoo!",
        "Y!J",
        "Yum!"
    ]
};
//# sourceMappingURL=English.js.map